import { render } from "./UzmanMain.vue?vue&type=template&id=460cebc4&scoped=true"
import script from "./UzmanMain.vue?vue&type=script&lang=js"
export * from "./UzmanMain.vue?vue&type=script&lang=js"

import "./UzmanMain.vue?vue&type=style&index=0&id=460cebc4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460cebc4"]])

export default __exports__